import styled from 'styled-components';
import {
  breakpoints,
  cssfonts,
  colors,
  pxToCssFont,
  pxToRem,
  shadows,
  getTypography,
} from '@vfit/shared/themes';

export const FilteredAppointments = styled.section`
  display: flex;
  flex-direction: column;
  margin: ${pxToRem(32, 0)};
  row-gap: ${pxToRem(16)};

  & > * {
    flex: 1;
  }

  @media (min-width: ${breakpoints.tablet}) {
    column-gap: ${pxToRem(24)};
    flex-direction: row;
    justify-content: center;
    margin: ${pxToRem(40, 0)};

    & > * {
      flex: 1;
      max-width: ${pxToRem(296)};
    }
  }
`;

export const ShowOtherAvailability = styled.p`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0;
`;

export const CalendarModalTitle = styled.h3`
  ${cssfonts.exbold}
  ${pxToCssFont(28, 36)}
  margin: ${pxToRem(0, 0, 29)};
  text-align: center;

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 48)}
  }
`;

export const CalendarAndNoSlotsBox = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(16)};
  margin: ${pxToRem(32, 0, 0)};

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const NoOtherSlotsTitle = styled.h3`
  ${getTypography('h6.extrabold')}
  margin: ${pxToRem(32, 0, 8)};

  @media (min-width: ${breakpoints.tablet}) {
    margin: ${pxToRem(0, 0, 8)};
  }
`;

export const NoOtherSlotsDescription = styled.div`
  ${getTypography('body1.regular')}
  padding-bottom: ${pxToRem(20 + 45 + 20)};

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoints.tablet}) {
    padding-bottom: 0;
  }
`;

export const CalendarModalFooter = styled.footer`
  align-items: center;
  background-color: ${colors.$ffffff};
  bottom: 0;
  box-shadow: ${shadows.card_overlay};
  display: flex;
  left: 0;
  padding: ${pxToRem(20, 44)};
  position: absolute;
  justify-content: center;
  width: 100%;

  @media (min-width: ${breakpoints.tablet}) {
    align-items: flex-start;
    box-shadow: none;
    padding: ${pxToRem(20, 40, 48)};

    button {
      width: ${pxToRem(220)};
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding: ${pxToRem(20, 109, 52)};
  }
`;

export const PlayerWrap = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(24)};
  height: calc(
    100% - ${pxToRem(72 - 49)}
  ); // futher margin plus title height --> so we center player

  justify-content: center;
`;

export const IconWrap = styled.div`
  width: ${pxToRem(35)};
`;

export const skeletonStyle = {
  groups: [{ heights: 116 }],
};
